export default __webpack_public_path__ + "static/media/health-app-img.a1613ae3.png";